module.exports = __webpack_public_path__ + "static/media/key-light-blue.eb977a7d.svg";